import * as React from "react";
import {StaticImage} from "gatsby-plugin-image";
import Config from "../../config.json";

const posterImages = {
    "Plenarsaal": "/images/overlays/Plenarsaal.jpg",
    "Senatssaal": "/images/overlays/Senatssaal.jpg",
    "Lesesaal": "/images/overlays/Lesesaal.jpg",
    "Akademiesaal": "/images/overlays/Akademiesaal.jpg",
    "Steinerner Saal": "/images/overlays/Steinerner Saal.jpg",
    "Steinerner_Saal": "/images/overlays/Steinerner Saal.jpg",
    "Kreuzgang": "/images/overlays/Kreuzgang.jpg",
    "Fassade": "/images/overlays/FassadeOp1.jpg",
};

const teaserImages = {
    "Plenarsaal": (
        <StaticImage alt="Plenarsaal" width={230} src="../../static/images/overlays/Plenarsaal.jpg"/>
    ),
    "Senatssaal": (
        <StaticImage alt="Senatssaal" width={230} src="../../static/images/overlays/Senatssaal.jpg"/>
    ),
    "Lesesaal": (
        <StaticImage alt="Lesesaal" width={230} src="../../static/images/overlays/Lesesaal.jpg"/>
    ),
    "Akademiesaal": (
        <StaticImage alt="Lesesaal" width={230} src="../../static/images/overlays/Akademiesaal.jpg"/>
    ),
    "Steinerner Saal": (
        <StaticImage alt="Steinerner Saal" width={230} src="../../static/images/overlays/Steinerner Saal.jpg"/>
    ),
    "Steinerner_Saal": (
        <StaticImage alt="Steinerner Saal" width={230} src="../../static/images/overlays/Steinerner Saal.jpg"/>
    ),
    "Kreuzgang": (
        <StaticImage alt="Kreuzgang" width={230} src="../../static/images/overlays/Kreuzgang.jpg"/>
    ),
    "Fassade": (
        <StaticImage alt="Fassade" width={230} src="../../static/images/overlays/FassadeOp1.jpg"/>
    ),
};

const RaumVideos = {
    "Akademiesaal": "BL_Akademiesaal_H264_WEB.mp4",
    "Kreuzgang": "BL_Kreuzgang_H264_WEB.mp4",
    "Opener": "BL_Opener_H264_WEB.mp4",
    "Senatssaal": "BL_Senatssaal_H264_WEB.mp4",
    "Steinerner_Saal": "BL_Steinerner_Saal_ohne_Maske_H264_WEB.mp4",
    "Fassade": "BL_Fassade_H264_WEB.mp4",
    "Lesesaal": "BL_Lesesaal_H264_WEB.mp4",
    "Plenarsaal": "BL_Plenarsaal_H264_WEB.mp4",
    "In_die_Nacht": "bonus/BL_In die Nacht_H264_WEB.mp4",
    "Volle_Drohnung_1": "bonus/BL_Volle Drohnung_1H264_WEB.mp4",
    "Volle_Drohnung_2": "bonus/BL_Volle Drohnung_2H264_WEB.mp4",
    "Volle_Drohnung_3": "bonus/BL_Volle Drohnung_3H264_WEB.mp4",
}

export {teaserImages, posterImages, RaumVideos, Config};
